/* eslint-disable @typescript-eslint/no-unused-vars */
import { gql } from '@apollo/client';

// SendGrid mailings — group contact list, recipient picker, send history
// (ТЗ 0015). Operation names deliberately differ from the backend field names
// (e.g. `MailCandidatesList` vs `groupMailCandidates`) to avoid codegen
// result-type collisions — the house rule across this repo.

export const SendgridTemplatesQuery = gql`
  query MailTemplatesList {
    sendgridTemplates {
      id
      name
      subject
      versionId
    }
  }
`;

export const SendgridGroupListQuery = gql`
  query MailGroupContactList($groupId: ID!) {
    sendgridGroupList(groupId: $groupId) {
      id
      sendgridListId
      name
      contactCount
      lastSyncStatus
      lastSyncedAt
      errorMessage
    }
  }
`;

export const GroupMailCandidatesQuery = gql`
  query MailCandidatesList(
    $groupId: ID!
    $mode: String
    $includeTerminated: Boolean
  ) {
    groupMailCandidates(
      groupId: $groupId
      mode: $mode
      includeTerminated: $includeTerminated
    ) {
      studentId
      studentName
      email
      agreementTitle
      agreementTerminated
      invoiceId
      invoiceNumber
      invoiceIssueDate
      invoiceDueDate
      invoiceOutstanding
      invoiceCurrency
      invoiceUrl
      isOverdue
      daysOverdue
      lastMailedAt
    }
  }
`;

// Polled while a job runs — keep the selection lean but complete enough that
// the progress panel never needs a second round-trip.
export const MailJobQuery = gql`
  query MailJobProgress($id: ID!) {
    mailJob(id: $id) {
      id
      status
      templateName
      total
      sentCount
      failedCount
      deliveredCount
      openedCount
      clickedCount
      bouncedCount
      errorMessage
      createdAt
      finishedAt
      createdByName
      recipients {
        id
        studentName
        email
        status
        reason
        invoiceNumber
        deliveredAt
        firstOpenedAt
        openCount
        firstClickedAt
        clickCount
        lastClickUrl
        bouncedAt
        bounceReason
        droppedAt
        dropReason
        unsubscribedAt
      }
    }
  }
`;

export const MailJobsQuery = gql`
  query MailJobsHistory($groupId: ID!, $limit: Int) {
    mailJobs(groupId: $groupId, limit: $limit) {
      id
      status
      templateName
      total
      sentCount
      failedCount
      deliveredCount
      openedCount
      clickedCount
      bouncedCount
      createdAt
      finishedAt
      createdByName
      recipients {
        id
        studentName
        email
        status
        reason
        deliveredAt
        firstOpenedAt
        openCount
        firstClickedAt
        clickCount
        lastClickUrl
        droppedAt
        dropReason
      }
    }
  }
`;
